/* Certification Schema Module */
import { code, email, mobile, password, required_string } from '@/libs/schema/schema';
import { z } from 'zod';
import { MEMBER_EMAIL_CERTIFICATION_TYPE, MOBILE_CERTIFICATION_TYPE, TEMP_EMAIL_CERTIFICATION_TYPE } from '../constant';

export const temp_certification_type = z.nativeEnum(TEMP_EMAIL_CERTIFICATION_TYPE);
export const member_certification_type = z.nativeEnum(MEMBER_EMAIL_CERTIFICATION_TYPE);
export const mobile_certification_type = z.nativeEnum(MOBILE_CERTIFICATION_TYPE);

export const CreateMobileCertificationReqBody = z
  .object({
    /**
     * user name
     * @example 홍길동
     * */
    name: required_string,
    mobile,
    certification_type: mobile_certification_type,
  })
  .required();

export const VerifyMobileCertificationReqBody = z
  .object({
    /**
     * user name
     * @example 홍길동
     * */
    name: required_string,
    mobile,
    code,
    /**
     * 인증 타입
     * @example RESET_PW
     * */
    certification_type: mobile_certification_type,
  })
  .required();

export const FindEmailReqBody = z
  .object({
    /**
     * user name
     * @example 홍길동
     * */
    name: required_string,
    mobile,
    code,
  })
  .required();

export const CreateEmailCertificationResetPwReqBody = z
  .object({
    email,
  })
  .required();

export const VerifyEmailCertificationReqBody = z
  .object({
    email,
    code,
    /**
     * 인증 타입
     * @example RESET_PW
     * */
    certification_type: temp_certification_type,
  })
  .required();

export const VerifyMemberEmailCertificationReqBody = z
  .object({
    email,
    code,
    /**
     * 인증 타입
     * @example RESET_PW
     * */
    certification_type: member_certification_type,
  })
  .required();

export const ResetPwReqBody = z.object({
  email,
  code,
  password,
});

export const CreateEmailCertificationCheckEmailReqBody = z
  .object({
    email,
    /**
     * 인증 타입
     * @example RESET_PW
     * */
    certification_type: temp_certification_type,
  })
  .required();

export const CreateMemberEmailCertificationCheckEmailReqBody = z
  .object({
    email,
    /**
     * 인증 타입
     * @example RESET_PW
     * */
    certification_type: member_certification_type,
  })
  .required();
